<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Contact'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Contact CorDx</div>
				<img class="bg" src="../../assets/img_h5/蒙版组 9@2x.webp" />
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Contact us</div>
				<div class="block_2_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x.png" />
					</div>
					<div class="right">
						5900 Windward Pkwy, Alpharetta, GA 30005
					</div>
				</div>
				<div class="block_2_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x.png" />
					</div>
					<div class="right">
						9540 Waples St. #C, San Diego, CA 92121
					</div>
				</div>
				<div class="block_2_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x (1).png" />
					</div>
					<div class="right">
						+1 (800) 711-5355
					</div>
				</div>
				<div class="block_2_el">
					<div class="left">
						<img src="../../assets/img_h5/icon@2x (2).png" />
					</div>
					<div class="right">
						<a style="color: #000000 !important;" href="mailto:info@cordx.com">info@cordx.com</a>
					</div>
				</div>
			</div>
			<!--块2-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true" :pageName="'About'"
			>
				<contact :titleText="'Submit'"></contact>
			</div>
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact.vue'  //联系我们
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//document.title = 'Contact - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	.block_3{
		padding: 0 20px 50px 20px;
	}
	/*块2*/
	.block_2{
		padding: 42px 20px 20px 20px;
		.block_2_el{
			padding-bottom: 20px;
			display: flex;
			align-items: center;
			.left{
				width: 30px;
				img{ width: 100%; }
			}
			.right{
				flex: 1;
				padding-left: 12px;
				font-size: 18px;
			}
		}
		.title{
			padding-bottom: 42px;
			font-size: 42px;
		}
	}
	/*块1*/
	.block_1{
		img.bg{
			width: 100%;
		}
		.tit{
			padding: 42px 20px 0 20px;
			font-size: 42px;
			text-align: center;
		}
	}
}
</style>
